import React from 'react';
import DiwoAIPic from "../../../images/background/diwoAIDtl.png"

const DiwoAIStatic = (props) => {
    return (
        <div>
            <div style={{ marginTop: 8 }}>
                <img src={DiwoAIPic} alt='' style={{ width: '100%', borderRadius: 4 }} />
            </div>
        </div>
    );
}

export default DiwoAIStatic;